module.exports = __webpack_public_path__ + "static/media/Funder1.80259669.png";